import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IsSmallScreen, MasterPages } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions, getPermissions, IPermission } from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";

export const UserList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();
  // const [permission,setPermissions]=useState<IPermission>({add:false,edit:false,view:false})
  // useEffect(()=>{
  //   const { edit, view, add } = getPermissions(MasterPages.Users);
  //   setPermissions({edit, view, add})
  // },[])
    AllPermissions.getInstance();
    const { add,edit,remove, view} =AllPermissions.getUserPermission;
  const source = {
    url: "auth/search",
    page: 1,
    pageSize: 10,
    filter: [

    ],
    sort: [  {
      "field": "UpdatedAt",
      "direction": "desc"
    }],
  };

  /**
   * Edit function
   * @param action 
   * @param row 
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/user/registration/edit/${row?.id}`)
    }

  };


  const columns: IColumns[] = [

    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default",
      //  sortable: true
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,
      isHide: isMobile,
      type: "default",
    },
    {
      header: "Created On",
      fieldName: "createdAt",
      isHide: isMobile,
      type: "date",
    },
    {
      header: "Updated On",
      fieldName: "updatedAt",
      isHide: isMobile,
      type: "date",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },

  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default",
      labelSx:{fontWeight:'bold'}
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,
  
      type: "default",
    },
    {
      header: "Created On",
      fieldName: "createdAt",
      isBoderRadious:true,
      type: "date",
    },
    {
      header: "Updated On",
      fieldName: "updatedAt",
      isBoderRadious:true,
      type: "date",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },


  ];
  const handleClick = () => {
    navigate('/user/registration')
  }

  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
      })
      return data
    }
  }
  return (
    <>
      <Grid container spacing={2}>
        {view ? <Grid item xs={12}>
          {!isMobile && <WSDataGrid
            id="userListGrid"
            title="Users"
            columns={columns}
            source={source}
            transFormData={transFormData}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            searchBox={{ fieldName: 'firstName,company,lastName,mobile' }}
            gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
          />
          }
          {isMobile &&
            <WSMobileDataGridAdvanced title={'Users'} addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}    transFormData={transFormData} columns={mobColumns} id="userListGrid" source={source} />
          }
        </Grid> : <PermissionDenied />
        }
      </Grid>
    </>
  )
})